import '../components/select-gift';
import Cart from '../services/cart';
import ProductTileSwipe from '../services/product-tile-swipe';
const checkPromotionsForSku = (tile, sku) => {
    Cart.getPromotionForSKU(sku)
        .then((promotions) => {
        promotions.forEach((promotion) => {
            promotion.actions.forEach((action) => {
                if (action.type === 'gift_of_choice') {
                    tile.querySelectorAll('select-gift').forEach((selectGiftButton) => {
                        const unavailableButton = tile.querySelector('.select-gift-wrapper .unavailable');
                        if (unavailableButton) {
                            if (action.eligible_skus !== null) {
                                action.eligible_skus.forEach((eligible) => {
                                    if (typeof eligible !== 'object') {
                                        return;
                                    }
                                    if (sku === eligible.sku) {
                                        selectGiftButton.setAttribute('index', eligible.data.index.toFixed(0));
                                        selectGiftButton.setAttribute('ruleId', eligible.data.ruleId.toFixed(0));
                                        selectGiftButton.setAttribute('actionIndex', eligible.data.actionIndex.toFixed(0));
                                        // Parametr multiplier zawsze ustawiamy na 1, aby przycisk "Wybierz prezent"
                                        // wybierał prezent w ramach pierwszego powtórzenia listy, zamiast w ostatnim
                                        // wygenerowanym
                                        selectGiftButton.setAttribute('multiplier', '1');
                                    }
                                });
                            }
                            selectGiftButton.style.display = 'block';
                            unavailableButton.style.display = 'none';
                        }
                    });
                }
            });
        });
    })
        .catch((err) => {
        console.error('Failed to get promotions for SKU', err);
    });
};
export default (tile) => {
    if (tile === null) {
        return;
    }
    const skuMeta = tile.querySelector('meta[itemprop="sku"]');
    if (skuMeta) {
        const sku = skuMeta.getAttribute('content');
        if (sku) {
            checkPromotionsForSku(tile, sku);
            Cart.addListener((event) => {
                if (event.name === 'promotionsChanged') {
                    checkPromotionsForSku(tile, sku);
                }
            });
        }
    }
    ProductTileSwipe.init(tile);
};
